import apiClient from './apiClient';

export async function getContactSettings() {
  const { data } = await apiClient.get('/api/admin/site/contact');
  return data;
}

export async function updateContactSettings(payload) {
  const { data } = await apiClient.put('/api/admin/site/contact', payload);
  return data;
}

export async function listContactInquiries(params = {}) {
  const { data } = await apiClient.get('/api/admin/contact-inquiries', { params });
  return data;
}

export async function updateInquiryStatus(id, status) {
  const { data } = await apiClient.put(`/api/admin/contact-inquiries/${id}/status`, {
    status,
  });
  return data;
}

export async function listPages() {
  const { data } = await apiClient.get('/api/admin/pages');
  return data;
}

export async function updatePage(slug, payload) {
  const { data } = await apiClient.put(`/api/admin/pages/${slug}`, payload);
  return data;
}
